
import React, { useState, useRef } from 'react'
import { Input, Tooltip } from 'antd'
import { setSelectionRange } from './tool'
import './index.css'

const Editor = ({initValue, onSubmit, onCancel}) => {
  const [value, setValue] = useState(initValue)
  const inputRef = useRef(null)
  React.useEffect(() => {
    // inputRef focus
    setTimeout(() => {
      const textarea = inputRef.current.resizableTextArea?.textArea || inputRef.current
      textarea.focus()
      const len = value.length || textarea.value.length
      console.info('>>> inputRef.current.focus()', len)
      setSelectionRange(textarea, len, len)
    }, 100)
  }, [])
  return (
    <>
      <div className={[
        'w-full bg-[rgba(245,245,245,1)] border-1px border-[rgba(0,0,0,1) rounded-[12px]',
        'min-height-[89px] px-[16px] pt-[16px] pb-[12px]',
        'editor-focus',
      ]}>
        <Input.TextArea
          ref={inputRef}
          value={value}
          onChange={e => setValue(e.target.value)}
          maxLength={99999}
          autoSize={{ minRows: 1, maxRows: 4 }}
          variant='borderless'
          className={[
            '!bg-transparent klklkl !text-16px !leading-snug !resize-none break-all overflow-x-hidden nw-scrollbar !transition-none',
            '!text-primary !mb-7px !px-0 !py-0',
          ]}
          autoFocus
        />
        <div className='flex flex-row justify-end items-center text-400 text-14px'>
          <div className={[
            'w-[60px] h-[32px] flex justify-center items-center rounded-8px',
            'border-1px border-[rgb(0,0,0)] mr-12px cursor-pointer',
            'hover:bg-[rgba(0,0,0,.03)]',
          ]}
          onClick={() => onCancel()}>取消</div>
          <div className={[
            'w-[60px] h-[32px] flex justify-center items-center rounded-8px',
            'bg-[rgb(0,0,0)] text-white cursor-pointer',
            'hover:bg-[#333]',
          ]}
          onClick={() => onSubmit(value)}>提交</div>
        </div>
      </div>
    </>
  )
}

const EditableText = ({ initalText, children, submit, disabled }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [newText, setNewText] = useState(initalText)
  const [copySuccess, setCopySuccess] = useState(false)

  // share mcp 页面不显示编辑按钮
  const [isSharePage,] = useState(location.href.includes('share/mcp'))

  const handleEditClick = () => {
    if (disabled) return
    setIsEditing(true)
    setNewText(initalText)
  }
  const onCopy = (e) => {
    setCopySuccess(true)
    // 复制文本到剪贴板
    console.info('>>> 复制文本到剪贴板', initalText)
    navigator.clipboard.writeText(initalText)
    setTimeout(() => {
      setCopySuccess(false)
    }, 3000)
  }
  const onSubmit = (newText) => {
    setIsEditing(false)
    console.info('>>> 提交文本', newText)
    submit && submit(newText)
  }

  return (
    <div className="relative">

      {isEditing
      ? <Editor
          initValue={newText}
          onSubmit={(value) => onSubmit(value)}
          onCancel={() => setIsEditing(false)}
        />
      : (
        <section className="flex flex-col justify-end items-end group relative">
          {children}
          <div className='invisible group-hover:visible absolute right-0 top-full flex flex-row justify-center items-center'>
            {
              !isSharePage
              && <Tooltip title="编辑" placement="bottom">
                  <div className={[
                    'w-[28px] mr-12px cursor-pointer group-1',
                    disabled ? 'cursor-default opacity-30' : ''
                  ]}>
                    <img
                      src='https://p5.ssl.qhimg.com/d/inn/78b9ecc6bb05/usermsg-edit.png'
                      className='w-[100%] group-1-hover:bg-[rgba(0,0,0,.03)] rounded-6px'
                      onClick={handleEditClick}
                    />
                  </div>
                </Tooltip>
            }
            <Tooltip title="复制" placement="bottom">
              <div className={[
                'w-[28px] cursor-pointer group-1',
              ]}>
                <img
                  src={
                    copySuccess
                      ? 'https://p2.ssl.qhimg.com/d/inn/d6a9592ee12b/usermsg-cped2.png'
                      : 'https://p0.ssl.qhimg.com/d/inn/65a3be3cd5db/usermsg-cp2.png'
                  }
                  onClick={(e) => onCopy(e)}
                  className='w-[100%] group-1-hover:bg-[rgba(0,0,0,.03)] rounded-6px'
                />
              </div>
            </Tooltip>
          </div>
        </section>
      )}
    </div>
  )
}

export default EditableText
